import { updateDeed } from "../../../services/api.js";

async function updateAllDescriptions(
  sortedDeeds,
  initialDescription,
  newDescription
) {
  const deedsToUpdate = sortedDeeds.filter(
    (deed) => deed.description === initialDescription
  );

  for (const deed of deedsToUpdate) {
    try {
      await updateDeed(deed.id, {
        description: newDescription,
        dateTime: deed.dateTime,
        timeSpent: deed.timeSpent || 0,
        notes: deed.notes || "",
        bucket: deed.bucket || "",
        pics: deed.pics || [],
      });
    } catch (error) {
      console.error(`Failed to update deed ${deed.id}:`, error);
    }
  }
}

export default updateAllDescriptions;
